import { Timestamp } from 'firebase/firestore';

export const getFormattedDate = (timestamp?: Timestamp | Date) => {
  if (!timestamp) return;

  let date;
  if (timestamp instanceof Date) {
    date = Timestamp.fromDate(new Date(timestamp)).toDate();
  } else {
    date = timestamp.toDate();
  }

  return `${date.toLocaleDateString('uk-UA', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })}`;
};
